import { Texture, TextureOptions } from "@/core/backends/webgl/texture"
import { WebGLBackend } from "../backends/webgl-backend"

export class DualBuffers {
	readBuffer: Texture
	writeBuffer: Texture

	backend: WebGLBackend
	label: string
	options?: TextureOptions

	constructor(backend: WebGLBackend, label: string, options?: TextureOptions) {
		this.label = label
		this.options = options
		this.backend = backend

		this.readBuffer = backend.createTexture({
			format: backend.textureFormat,
			...options,
			label: label + ".read",
		})
		this.writeBuffer = backend.createTexture({
			format: backend.textureFormat,
			...options,
			label: label + ".write",
		})
	}

	swapBuffers() {
		const temp = this.readBuffer
		this.readBuffer = this.writeBuffer
		this.writeBuffer = temp
	}

	updateSize(width: number, height: number) {
		this.readBuffer.updateSize(width, height)
		this.writeBuffer.updateSize(width, height)
	}

	reset() {
		this.readBuffer.reset()
		this.writeBuffer.reset()
	}
}
